var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"mb-3",attrs:{"header":"Top 10 Hospitals by Transplants"}},[(_vm.series.length > 0)?_c('apexchart',{attrs:{"type":"bar","height":"350","options":_vm.chartOptions,"series":_vm.series}}):_c('div',{staticClass:"text-center text-muted py-5"},[_vm._v("No data available")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }